import { instagramPosts } from '../../../mocks/artworks';

export default function InstagramSection() {
  const instagramLinks = [
    "https://www.instagram.com/p/DRFFP2YAM4o/",
    "https://www.instagram.com/p/DQpHjn8gM99/?img_index=1",
    "https://www.instagram.com/p/DRA2VyqAPdN/?img_index=1",
    "https://www.instagram.com/p/DQbq98WgC2H/",
    "https://www.instagram.com/p/DQaOZ3VAFFK/",
    "https://www.instagram.com/p/DNR_bB4M492/"
  ];

  return (
    <section id="instagram" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-20">
        <div className="text-center mb-16">
          <div className="flex items-center justify-center gap-3 mb-4">
            <div className="w-8 h-8 flex items-center justify-center bg-gradient-to-br from-[#833AB4] via-[#FD1D1D] to-[#F77737] rounded-lg">
              <i className="ri-instagram-line text-white text-lg"></i>
            </div>
            <a 
              href="https://www.instagram.com/davidnievesart/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-base font-medium text-gray-800 hover:text-[#e8a65b] transition-colors cursor-pointer"
            >
              @davidnievesart
            </a>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Sígueme en <span className="text-[#e8a65b]">Instagram</span>
          </h2>
          <p className="text-base text-gray-600 max-w-2xl mx-auto">
            Descubre mi proceso creativo, obras en progreso y momentos detrás de escena
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-12">
          {instagramPosts.slice(0, 6).map((post, index) => (
            <a
              key={post.id}
              href={instagramLinks[index]}
              target="_blank"
              rel="noopener noreferrer"
              className="group relative overflow-hidden rounded-xl shadow-md hover:shadow-2xl transition-all duration-300 cursor-pointer"
            >
              <div className="w-full h-64">
                <img
                  src={post.image}
                  alt={`Instagram post ${post.id}`}
                  className="w-full h-full object-cover object-top transform group-hover:scale-110 transition-transform duration-500"
                />
              </div>
              <div className="absolute inset-0 bg-black/60 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                <div className="flex items-center gap-6 text-white">
                  <div className="flex items-center gap-2">
                    <i className="ri-heart-fill text-2xl"></i>
                    <span className="text-lg font-medium">{post.likes.toLocaleString()}</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <i className="ri-chat-3-fill text-2xl"></i>
                    <span className="text-lg font-medium">{post.comments}</span>
                  </div>
                </div>
              </div>
            </a>
          ))}
        </div>

        <div className="text-center">
          <a
            href="https://www.instagram.com/davidnievesart/"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-8 py-4 bg-[#e8a65b] text-white rounded-full hover:bg-[#d99549] transition-all duration-300 text-sm font-medium whitespace-nowrap cursor-pointer shadow-lg hover:shadow-xl transform hover:scale-105"
          >
            Ver Más en Instagram
            <i className="ri-arrow-right-up-line text-lg"></i>
          </a>
        </div>
      </div>
    </section>
  );
}